<template>
    <div>
        <section class="home-gallery" v-if="postData && postData.length">
            <projectGallery :data="postData" />
        </section>
    </div>
</template>

<script>

import projectGallery from '@/components/blocks/ProjectGallery'

import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'projects-slider',
    props: ['id', 'type'],
    components: {
        projectGallery
    },
    data(){
        return{
            visible: false,
            loading: false,
        }
    },
    mounted(){
        //console.log(this.id[0])
    },
    computed: {
        ...mapGetters([
            'getPostById',
        ]),
        postData(){
            const postType = this.type || 'projects'
            let posts = this.id[0]

            
            let tests = [];
            posts.forEach( (post, i) => {
                let project = this.getPostById( post )
                if(project && i <= 2){ 
                    tests.push(project); 
                };
               
            });
            posts = tests

            return posts
        }
    },
    methods: {
        
        checkVisibility(vis, el){
            if(vis && !this.visible) {
                this.visible = true
            }
        }
    },
}
</script>